import { HeaderSection } from '../../layouts/core/header-section';
import { ContactUsPage } from '../../pages/contact';
import { Breakpoint, useTheme } from '@mui/material/styles';
import { RycLogo } from '@onesource/icons';
import { createFileRoute, Link } from '@tanstack/react-router';
import { IoHomeOutline } from 'react-icons/io5';
import Button from '@mui/material/Button';
import { isLoggedIn } from '@onesource/services';

function ContactRoute() {
  const theme = useTheme();
  const layoutQuery: Breakpoint = 'md';

  return (
    <>
      <HeaderSection
        layoutQuery={layoutQuery}
        slotProps={{ container: { maxWidth: false } }}
        slots={{
          leftArea: <RycLogo color={theme.palette.primary.light} width="130px" height="60px" />,
          rightArea: (
            <Button
              component={Link}
              to={isLoggedIn() ? '/' : '/auth/login'}
              variant="outlined"
              startIcon={<IoHomeOutline />}
              sx={{
                border: 0,
                '&:hover': {
                  border: 0,
                },
              }}
            >
              Home
            </Button>
          ),
        }}
      />
      <ContactUsPage />
    </>
  );
}

export const Route = createFileRoute('/contact/')({
  component: ContactRoute,
});
